import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUser, FaTag } from 'react-icons/fa';
import { useSelector } from 'react-redux';

import one from '../../assest/blogsone.png';
import two from '../../assest/blogtwo.png';
import three from '../../assest/blogthree.png';

// Translation dictionary
const translations = {
  gb: { // English
    admin: "By Admin",
    readMore: "Read More →",
    categories: {
      technology: "Technology",
      solutions: "Solutions"
    },
    posts: {
      1: "Essential Safety protocols For Construction",
      2: "Keep Your Business Safe & Ensure High Availability",
      3: "Which Yoga Hybrid is Right For You?",
      4: "Essential Safety protocols For Construction",
      5: "Keep Your Business Safe & Ensure High Availability",
      6: "Which Yoga Hybrid is Right For You?"
    }
  },
  sa: { // Arabic
    admin: "بواسطة المدير",
    readMore: "اقرأ المزيد →",
    categories: {
      technology: "تكنولوجيا",
      solutions: "حلول"
    },
    posts: {
      1: "بروتوكولات السلامة الأساسية للبناء",
      2: "حافظ على أمان عملك وضمان التوافر العالي",
      3: "أي هجين اليوجا مناسب لك؟",
      4: "بروتوكولات السلامة الأساسية للبناء",
      5: "حافظ على أمان عملك وضمان التوافر العالي",
      6: "أي هجين اليوجا مناسب لك؟"
    }
  },
  fr: { // French
    admin: "Par Admin",
    readMore: "Lire la suite →",
    categories: {
      technology: "Technologie",
      solutions: "Solutions"
    },
    posts: {
      1: "Protocoles de sécurité essentiels pour la construction",
      2: "Protégez votre entreprise et assurez une haute disponibilité",
      3: "Quel hybride de yoga vous convient le mieux ?",
      4: "Protocoles de sécurité essentiels pour la construction",
      5: "Protégez votre entreprise et assurez une haute disponibilité",
      6: "Quel hybride de yoga vous convient le mieux ?"
    }
  },
  de: { // German
    admin: "Von Admin",
    readMore: "Weiterlesen →",
    categories: {
      technology: "Technologie",
      solutions: "Lösungen"
    },
    posts: {
      1: "Wesentliche Sicherheitsprotokolle für den Bau",
      2: "Halten Sie Ihr Unternehmen sicher und gewährleisten Sie hohe Verfügbarkeit",
      3: "Welches Yoga-Hybrid ist das Richtige für Sie?",
      4: "Wesentliche Sicherheitsprotokolle für den Bau",
      5: "Halten Sie Ihr Unternehmen sicher und gewährleisten Sie hohe Verfügbarkeit",
      6: "Welches Yoga-Hybrid ist das Richtige für Sie?"
    }
  }
};

const blogPosts = [
  {
    id: 1,
    date: '20',
    month: 'June',
    category: 'technology',
    titleKey: 1,
    image: one,
  },
  {
    id: 2,
    date: '28',
    month: 'June',
    category: 'solutions',
    titleKey: 2,
    image: two,
  },
  {
    id: 3,
    date: '28',
    month: 'June',
    category: 'solutions',
    titleKey: 3,
    image: three,
  },
  {
    id: 4,
    date: '20',
    month: 'June',
    category: 'technology',
    titleKey: 4,
    image: one,
  },
  {
    id: 5,
    date: '28',
    month: 'June',
    category: 'solutions',
    titleKey: 5,
    image: two,
  },
  {
    id: 6,
    date: '28',
    month: 'June',
    category: 'solutions',
    titleKey: 6,
    image: three,
  },
];

const BlogCards = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb; // Default to English if language not found

  // Month translations
  const monthTranslations = {
    June: {
      gb: "June",
      sa: "يونيو",
      fr: "Juin",
      de: "Juni"
    }
  };

  return (
    <div className="container py-5">
      <div className="row g-4">
        {blogPosts.map((post) => (
          <div className="col-12 col-sm-6 col-lg-4" key={post.id}>
            <Link to="/Blogs-Team" className="text-decoration-none text-dark">
              <div className="position-relative bg-white shadow-sm rounded overflow-hidden">
                <div className="position-relative">
                  <img
                    src={post.image}
                    className="w-100"
                    alt={t.posts[post.titleKey]}
                    style={{ height: '250px', objectFit: 'cover' }}
                  />
                  <div
                    className="position-absolute top-0 start-0 bg-white text-center py-1 px-2 m-2 rounded"
                    style={{ minWidth: '50px' }}
                  >
                    <div className="fw-bold">{post.date}</div>
                    <small className="text-muted">
                      {monthTranslations[post.month]?.[language] || post.month}
                    </small>
                  </div>
                </div>

                <div
                  className="bg-white p-3 shadow position-relative"
                  style={{ marginTop: '-30px', zIndex: 1 }}
                >
                  <div className="mb-2 small text-muted d-flex align-items-center gap-2">
                    <span className="d-flex align-items-center gap-1">
                      <FaUser /> {t.admin}
                    </span>
                    <span className="d-flex align-items-center gap-1 text-danger">
                      <FaTag /> {t.categories[post.category]}
                    </span>
                  </div>
                  <h6 className="card-title">{t.posts[post.titleKey]}</h6>
                  <span className="text-primary">{t.readMore}</span>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogCards;